module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"no_item_message":"已登記的視頻不存在。"}}')
  delete Component.options._Ctor
}
